import { ResolvedTheme, Themes } from '@cko/dashboard-shared';
import {
  useThemes,
  getThemeFromLocalStorage,
  getDefaultTheme,
  resolveTheme,
} from '../../VisualProvider';
import { UserProfile } from './useGetUserProfile';
import { useUpdateTheme } from './useUpdateTheme';

export const useUserTheme = (profile: UserProfile | undefined) => {
  const { updateTheme: updateStoredTheme } = useThemes();

  const { mutateAsync: updateProfileTheme } = useUpdateTheme();

  const profileTheme: Themes | undefined = profile && profile.theme?.name;
  const storedTheme: Themes | null = getThemeFromLocalStorage();
  const defaultTheme: Themes = getDefaultTheme();
  const currentTheme: Themes = storedTheme || profileTheme || defaultTheme;
  const resolvedTheme: ResolvedTheme = resolveTheme(currentTheme);
  const updateTheme = async (theme: Themes) => {
    updateProfileTheme({ theme });
    updateStoredTheme(theme);
  };

  return {
    resolvedTheme,
    currentTheme,
    updateTheme,
  };
};
